import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { getTheme } from './utils/preferences';
import PrivateRoute from './components/PrivateRoute';
import CounterpartyLayout from './components/CounterpartyLayout';
import ToastContainer from './components/ToastContainer';
import Login from './pages/Login';
import VndDashboardPage from './pages/VndDashboardPage';
import VndRequestsPage from './pages/VndRequestsPage';
import VndPayoutsPage from './pages/VndPayoutsPage';
import VndQrProfilesPage from './pages/VndQrProfilesPage';
import VndSmsPhonesPage from './pages/VndSmsPhonesPage';
import VndTeamPage from './pages/VndTeamPage';
import VndBalanceHistoryPage from './pages/VndBalanceHistoryPage';
import VndSettingsPage from './pages/VndSettingsPage';

function LayoutWrapper() {
  return (
    <CounterpartyLayout>
      <Outlet />
    </CounterpartyLayout>
  );
}

export default function App() {
  useEffect(() => {
    const theme = getTheme();
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route element={<LayoutWrapper />}>
            <Route path="/requests" element={<VndRequestsPage />} />
            <Route path="/payouts" element={<VndPayoutsPage />} />
            <Route path="/qr-profiles" element={<VndQrProfilesPage />} />
            <Route path="/sms-phones" element={<VndSmsPhonesPage />} />
            <Route path="/dashboard" element={<VndDashboardPage />} />
            <Route path="/team" element={<VndTeamPage />} />
            <Route path="/transactions" element={<VndBalanceHistoryPage />} />
            <Route path="/settings" element={<VndSettingsPage />} />
            <Route path="/rates" element={<Navigate to="/qr-profiles" replace />} />
          </Route>
        </Route>
        <Route path="/" element={<Navigate to="/qr-profiles" replace />} />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}
